export function membershipScope(event: {
  title?: string | null;
  event?: {
    ancestry?: { title?: readonly (string | null)[] | null } | null;
  } | null;
}) {
  return (
    [...(event.event?.ancestry?.title ?? []), event.title]
      .filter(Boolean)
      .join(' → ') || 'Event'
  );
}
